import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const PopupContent = styled.div`
    color: #202124;
    opacity: 1;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    width: 735px;
    height: ${({ isBulkAdd,isScanItem }) => (isBulkAdd ? '500px' :isScanItem? '300px': '248px')};
    /* margin-top: 18px; */
    ${media.mobileDevice`
    width: 328px;
    height: ${({ isBulkAdd,isScanItem }) => (isBulkAdd ? '500px' :isScanItem?'370px': '270px')};
`}
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const Title = styled.div`
    letter-spacing: 0px;
    color: #130e4a;
    opacity: 1;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    ${media.mobileDevice`
    font-size: 15px;
`}
`;

export const Icon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 21.03px;
    height: 20px;
    display: ${({ show }) => (show ? 'block' : 'none')};
    cursor: ${({ hideCursor }) => (hideCursor ? 'unset' : 'pointer')};
    ${media.mobileDevice`
    display: block;
    `}
`;

export const ReportUsageButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};
    padding-right: 14px;
    ${media.mobileDevice`
    padding-right: 0px;
    justify-content: flex-end;
    position: absolute;
    right: 13px;
    bottom: 13px;
    `}
`;
